<div class="card d-flex flex-column flex-grow-1">
  <div class="card-body d-flex flex-column flex-grow-1">
    <h4 class="modal-title">Voicemail MSG</h4>
    <div class="row">
      <div class="col-12">
        <form [formGroup]="msgForm">
          <div class="row mt1">
            <audio id="audiocontrol" controls controlsList="nodownload" class="col-7" [src]="url$ | async">
              Your browser does not support the audio element.
            </audio>
          </div>
          <div class="row mt-1">
            <label for="first" class="col-2 col-form-label">First</label>
            <div class="col-3">
              <input id="first" type="text" class="form-control" formControlName="first" />
              <input type="hidden" id="sessionid" formControlName="sessionid" />
              <input type="hidden" id="dnis" formControlName="dnis" />
            </div>
          </div>
          <div class="row mt-1">
            <label for="last" class="col-2 col-form-label">Last</label>
            <div class="col-3">
              <input id="last" type="text" class="form-control" formControlName="last" />
            </div>
          </div>
          <div class="row mt-1">
            <label for="phone" class="col-2 col-form-label">Contact Number</label>
            <div class="col-3">
              <input id="phone" type="text" class="form-control" formControlName="phone" />
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-secondary btn-block" (click)="dialNumber()">
                Dial
              </button>
            </div>
          </div>
          <div class="row mt-1">
            <label for="notes" class="col-2 col-form-label">Notes</label>
            <div class="col-3">
              <textarea rows="10" cols="50" id="notes" type="text" class="form-control"
                formControlName="notes"></textarea>
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-secondary btn-block" (click)="contacted()">
                Contacted
              </button>
              <button type="button" class="btn btn-secondary btn-block" (click)="reschedule()">
                Reschedule
              </button>
              <button type="button" class="btn btn-secondary btn-block" (click)="discard()">
                Discard
              </button>
            </div>
          </div>
          <div class="row mt-1">
            <label for="entered" class="col-2 col-form-label">Entered</label>
            <div class="col-3">
              <input id="entered" type="text" class="form-control" formControlName="entered" readonly />
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-secondary btn-block" (click)="cancel()">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>